import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.5 9.5V9L5.41421 7.91421C4.82885 7.32885 4.5 6.53493 4.5 5.70711V5.70711C4.5 4.15378 5.64218 2.83683 7.1799 2.61716L7.22932 2.6101C7.74051 2.53707 8.25949 2.53707 8.77068 2.6101L8.8201 2.61716C10.3578 2.83683 11.5 4.15378 11.5 5.70711V5.70711C11.5 6.53493 11.1711 7.32885 10.5858 7.91421L9.5 9V9.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.5 11.5H9.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7 13.5H9"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default Icon;
